export default __webpack_public_path__ + "static/media/logo06.8911cb5d.png";